const KEY = "pending_reading";
const MAX_AGE_MS = 24 * 60 * 60 * 1000;

export const savePendingReading = (draw) => {
  try { localStorage.setItem(KEY, JSON.stringify({ savedAt: Date.now(), draw })); } catch (e) {}
};

export const clearPendingReading = () => {
  try { localStorage.removeItem(KEY); } catch (e) {}
};

// Returns the stored draw (if valid and fresh) and always removes it from storage.
export const takePendingReading = () => {
  let entry = null;
  try { entry = JSON.parse(localStorage.getItem(KEY) || "null"); } catch (e) {}
  clearPendingReading();
  const draw = entry?.draw;
  if (!draw?.deck?.id || !draw?.spread?.id || !Array.isArray(draw.cards)) return null;
  if (!entry.savedAt || Date.now() - entry.savedAt > MAX_AGE_MS) return null;
  return draw;
};

export const hasPendingReading = () => {
  try { return localStorage.getItem(KEY) !== null; } catch (e) { return false; }
};
